<template>
  <vx-card class="editor-mid-card" :class="{'bg-dark-custom': (!isAboutTabComplete && aboutDataCalculationFinished)}" style="position: relative">
    <div v-if="userData && aboutDataCalculationFinished">
      <div v-if="isAboutTabComplete && organizationSlug === 'dpd-belux'">
        <personality-dpd-belux :personalityData="personalityData" />
      </div>
      <div>

        <personality-default :personalityData="personalityData" />
      </div>

    </div>
  </vx-card>
</template>

<script>
import PersonalityDefault from "./PersonalityDefault.vue";
import PersonalityDpdBelux from "./PersonalityDpdBelux.vue";
import organizationConfig from "@/assets/data/organization-config.js";

export default {
  data() {
    return {
      organizationConfig,
      isEmailFilled: false,
      isProfilePictureFilled: false,
      isDOBFilled: false,
      isFirstNameFilled: false,
      isCareerObjectiveFilled: false,
      isProfessionFilled: false,
      isAboutFilled: false,
      aboutDataCalculationFinished: false
    };
  },
  components: {
    PersonalityDefault,
    PersonalityDpdBelux,
  },
  computed: {
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    userData() {
      return this.$store.state.users.data;
    },
    organizationSlug() {
      return this.$store.state.organization.organizationSlug;
    },
    locale() {
      return this.$i18n.locale;
    },
    personalityData() {
      console.log('this.locale',this.locale);
      return this.organizationConfig[this.organizationSlug].personalityTraits[
       'es'
        ];
    },
    boardUser() {
      console.log('userBoardData',this.$store.state.boards.userBoardData);
      return this.$store.state.boards.userBoardData;
    },
    isAboutTabComplete() {
      if (
        this.isEmailFilled &&
        this.isProfilePictureFilled &&
        this.isDOBFilled &&
        this.isFirstNameFilled &&
        this.isCareerObjectiveFilled &&
        this.isProfessionFilled &&
        this.isAboutFilled
      ) {

        return true;
      }
      return false;
    },
  },
  watch: {
    userData(newVal) {
      this.verifyAboutTab();
    }
  },
  methods: {
    verifyAboutTab() {
      this.aboutDataCalculationFinished = false;
      if (this.userData) {
        if (this.userData.email) this.isEmailFilled = true;
        if (this.userData.profilePictureUrl) this.isProfilePictureFilled = true;
        if (this.userData.dob) this.isDOBFilled = true;
        if (this.userData.firstName) this.isFirstNameFilled = true;
        if (this.userData.careerObjective) this.isCareerObjectiveFilled = true;
        if (this.userData.profession) this.isProfessionFilled = true;
        if (this.userData.about) this.isAboutFilled = true;

        this.aboutDataCalculationFinished = true;
      }
    },
  },
  mounted() {
    // verify about tab completion
    this.verifyAboutTab();
  },
};
</script>

<style scoped>
.vertical-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.bg-dark-custom {
  background-color: lightgray!important;
  transition: none;
}
</style>
